import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { templateService } from '../services/db';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import './TemplateSelectionPage.css';

function TemplateSelectionPage() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadTemplates = async () => {
      console.log("==== TEMPLATE SELECTION PAGE - LOAD TEMPLATES =====");
      console.log("Current user:", currentUser);
      console.log("Event ID:", eventId);
      
      try {
        if (!currentUser) {
          console.log("No current user, navigating to login");
          navigate('/login');
          return;
        }
        
        console.log("Calling templateService.getAll with userId:", currentUser.id);
        const userTemplates = await templateService.getAll(currentUser.id);
        console.log("TEMPLATE SELECTION PAGE received templates:", userTemplates);
        setTemplates(userTemplates || []);
      } catch (err) {
        console.error("Error in TEMPLATE SELECTION PAGE loadTemplates:", err);
        setTemplates([]);
      } finally {
        setLoading(false);
        console.log("==== END TEMPLATE SELECTION PAGE - LOAD TEMPLATES =====");
      }
    };
    
    loadTemplates();
  }, [currentUser, navigate]);

  const handleSelectTemplate = (templateId) => {
    console.log("Template selected:", templateId);
    
    if (templateId === null) {
      // Start from scratch
      navigate(`/events/${eventId}/invitation/new`);
    } else {
      // Find the template in our loaded templates
      const selectedTemplate = templates.find(t => t.id === templateId);
      
      if (selectedTemplate) {
        console.log("Selected template:", selectedTemplate.name);
        console.log("Elements count:", selectedTemplate.elements?.length || 0);
      }
      
      // Navigate to new invitation with template ID
      navigate(`/events/${eventId}/invitation/new?templateId=${templateId}`);
    }
  };

  if (loading) {
    return <div className="loading">Loading templates...</div>;
  }

  return (
    <div className="template-selection-page">
      <Header />
      
      <div className="template-selection-container">
        <div className="template-selection-header">
          <Link to={`/events/${eventId}`} className="back-button">
            ← Back to Event
          </Link>
          <h1>Choose a Template</h1>
          <p>Select a template to create your invitation or start from scratch</p>
        </div>

        <div className="templates-grid">
          {/* Blank Canvas Option */}
          <div className="template-card blank-template" onClick={() => handleSelectTemplate(null)}>
            <div className="template-preview">
              <div className="blank-canvas-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="#666"/>
                  <path d="M12 12H17V14H12V12ZM12 7H17V9H12V7ZM12 17H17V19H12V17ZM7 7H10V10H7V7ZM7 12H10V15H7V12Z" fill="#666"/>
                </svg>
              </div>
              <div className="blank-label">Blank Canvas</div>
            </div>
            <div className="template-info">
              <h3>Start from Scratch</h3>
              <p>Create your own design with a blank canvas</p>
            </div>
          </div>

          {/* Display existing templates */}
          {templates.map(template => {
            console.log("Rendering template in selection:", template.id, template.name, 
              "Elements:", template.elements?.length || 0);
            
            return (
              <div 
                key={template.id} 
                className="template-card" 
                onClick={() => handleSelectTemplate(template.id)}
                data-template-id={template.id}
              >
                <div className="template-preview">
                  {template.thumbnail ? (
                    <img src={template.thumbnail} alt={template.name} />
                  ) : (
                    <div className="placeholder-thumbnail">
                      <span>{template.name.charAt(0)}</span>
                    </div>
                  )}
                </div>
                <div className="template-info">
                  <h3>{template.name}</h3>
                  <p>{template.description || 'Custom template'}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default TemplateSelectionPage; 